import { BrowserRouter, Route, Routes } from "react-router-dom";
import NabVar from "../components/NavBar";
import Home from "../view/Home";
import Result from "../view/Result";

const AppRouters = () => {
  return (
    <BrowserRouter>
      <div className="containerPrimaryX">
        <NabVar />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/result" element={<Result />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default AppRouters;
